import EPubTableOfContents, {
  EPubTableOfContentsProps,
} from "./EPubTableOfContents";

export default EPubTableOfContents;
export type { EPubTableOfContentsProps };
